import { reduce } from '@atlaskit/adf-utils/traverse';

const extensionNodeSet = new Set(['extension', 'inlineExtension', 'bodiedExtension']);

export const getContentStats = (draftBody: string | null | undefined) => {
	if (!draftBody) {
		return {};
	}

	try {
		const doc = JSON.parse(draftBody);
		return reduce(
			doc,
			(acc, node) => {
				const key = extensionNodeSet.has(node.type)
					? `${node.type}:${node.attrs?.extensionKey}`
					: node.type;

				acc[key] = (acc[key] || 0) + 1;
				return acc;
			},
			{},
		);
	} catch (e) {
		return {};
	}
};
